import { Card } from 'reactstrap';
import HomologationFormLoader from './parts/Loaders/HomologationFormLoader';
import ApproverUsersSection from './parts/ApproverUsersSection';

export default function Homologation() {
  return (
    <Card className="p-4">
      <HomologationFormLoader>
        <ApproverUsersSection />
      </HomologationFormLoader>
    </Card>
  );
}
